(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aloe-glossar"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('[data-aloe-glossary]').forEach(function(root){var input=root.querySelector('[data-glossary-search]');var items=[].slice.call(root.querySelectorAll('[data-glossary-item]'));var groups=[].slice.call(root.querySelectorAll('[data-glossary-group]'));var count=root.querySelector('[data-glossary-count]');var empty=root.querySelector('[data-glossary-empty]');if(!input)return;count.textContent=items.length;input.addEventListener('input',function(){var query=this.value.toLocaleLowerCase('de').trim();var visible=0;items.forEach(function(item){var match=!query||item.dataset.search.indexOf(query)>-1;item.hidden=!match;if(match)visible++});groups.forEach(function(group){group.hidden=!group.querySelector('[data-glossary-item]:not([hidden])')});count.textContent=visible;empty.hidden=visible!==0})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aloe-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aloe-hero-slider')) {
    customElements.define('aloe-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-aloe-slide]')];
        this.dots = [...this.querySelectorAll('[data-aloe-dot]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Number(this.dataset.interval) || 6500;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('[data-aloe-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-aloe-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.aloeDot), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.index - 1, true);
          if (event.key === 'ArrowRight') this.show(this.index + 1, true);
        });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-aloe-slide]');
          if (slide) this.show(Number(slide.dataset.index));
          this.stop();
        });
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(nextIndex, restart = false) {
        if (this.slides.length < 2) return;
        const target = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === target;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, index) => {
          const active = index === target;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        this.index = target;
        if (restart) {
          this.stop();
          this.start();
        }
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.reducedMotion || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  (() => {
    let pending = false;
    const cardSelector = '[data-aloe-delivery]';
    const radioSelector = 'input[name="cart_delivery"]';
    const lineFor = {versand:'Lieferoption: Versand', abholung:'Lieferoption: Abholung im Unternehmen'};
    function withChoice(note, value) {
      const lines = (note || '').split(/\r?\n/).filter(line => !Object.values(lineFor).includes(line.trim()));
      const kept = lines.join('\n');
      return kept + (kept && !kept.endsWith('\n') ? '\n' : '') + lineFor[value];
    }
    document.addEventListener('change', async event => {
      const target = event.target;
      if (!target.matches?.(radioSelector) || !target.checked) return;
      const card = target.closest(cardSelector);
      if (!card || !Object.hasOwn(lineFor, target.value)) return;
      if (pending) return;
      const value = target.value;
      let confirmed = card.dataset.aloeDelivery;
      let message = 'Lieferoption konnte nicht gespeichert werden. Bitte versuche es noch einmal.';
      pending = true;
      card.querySelectorAll(radioSelector).forEach(radio => radio.disabled=true);
      card.querySelector('[role="status"]').textContent = 'Lieferoption wird gespeichert …';
      const locked = [...document.querySelectorAll('#main-cart-footer .cart__block--center:not([inert]), #main-cart-footer .cart__ctas:not([inert])')];
      locked.forEach(node => node.inert=true);
      try {
        const current = await fetch(card.dataset.cartRead, {cache:'no-store',headers:{Accept:'application/json'}});
        if (!current.ok) throw new Error();
        const cart = await current.json();
        const note = withChoice(cart.note, value);
        const saved = await fetch(card.dataset.cartWrite, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note})});
        if (!saved.ok || (await saved.json()).note !== note) throw new Error();
        confirmed = value;
        message = value === 'abholung' ? 'Abholung gespeichert.' : 'Versand gespeichert.';
        const editor = document.querySelector('#Cart-note');
        if (editor && document.activeElement !== editor) editor.value=note;
      } catch {
        // Keep the last confirmed choice when the cart endpoint is unavailable.
      } finally {
        pending = false;
        locked.forEach(node => node.inert=false);
        const shown = document.querySelector(cardSelector);
        if (shown) {
          shown.dataset.aloeDelivery = confirmed;
          shown.querySelectorAll(radioSelector).forEach(radio => {radio.checked=radio.value===confirmed;radio.disabled=false;});
          shown.querySelector('[role="status"]').textContent = message;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
